module.exports = __webpack_public_path__ + "img/bank.624944f4.svg";